import { Services } from '../../../components/Services/Services'
import { Categories } from '../../../components/Categories/Categories'
import { useBookingContext } from '../../../providers/BookingFormProvider/BookingFormProvider'
import { CustomScroll } from 'react-custom-scroll'
import './Steps.scss'

export const ServicesStep = () => {
    const { categories, extractedAttrCats } = useBookingContext()

    return (
        <>
            {categories &&
                categories?.length > 0 &&
                (extractedAttrCats.length > 1 ||
                    extractedAttrCats.length === 0) && <Categories />}
            <CustomScroll flex="1" className={'wbk_step__scroll-wrapper'}>
                <Services />
            </CustomScroll>
        </>
    )
}
